import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

import es from 'vuetify/es5/locale/es';
import en from 'vuetify/es5/locale/en';
import fr from 'vuetify/es5/locale/fr';

import i18n from '@/plugins/i18n';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#6E17A5',
        secondary: '#FF7900',
        light: '#f2b37b',
        accent: '#fff6ef',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
    },
  },
  lang: {
    locales: { es, en, fr },
    current: i18n.locale,
  },
});